<script>
  import { onDestroy, onMount, tick } from "svelte";
  import DialogBase2 from "../dialog/DialogBase2.svelte";
  import DialogTitle from "../dialog/DialogTitle.svelte";
  import DialogSplitter from "../dialog/DialogSplitter.svelte";
  import DialogContent from "../dialog/DialogContent.svelte";
  import { translate } from "../../i18n/i18next.js";

  export let onClose

  let dialog
  onMount(async () => {
    await tick()
    dialog.showModal()
  })
  onDestroy(() => {
    dialog.close()
  })
</script>

<DialogBase2 bind:dialog={dialog} onClose={onClose}>
  <DialogTitle>
    {translate("generic.filterShort")}
  </DialogTitle>
  <DialogSplitter />
  <DialogContent>
    <slot />
  </DialogContent>
</DialogBase2>
